const SET_ERROR = (state, errorId) => {
  state.errorId = errorId;
};

const SET_LANGUAGE = (state, lang) => {
  state.language = lang;
};

const SET_DEMO = (state, status) => {
  state.demo = status;
};

const SET_SIDENAV = (state, open) => {
  state.sideNavOpen = open;
};

const SET_APP_MODE = (state, mode) => {
  state.appMode = mode;
};

export default {
  SET_ERROR,
  SET_LANGUAGE,
  SET_DEMO,
  SET_SIDENAV,
  SET_APP_MODE,
};
